import { css } from '@emotion/css';

export const draggableCursorStyle = css`
  cursor: grabbing;
`;
